module.exports = __webpack_public_path__ + "img/hkis-white.a992f440.png";